export default {"src":"/login-app/[GIT_HASH]/_next/static/media/test.65405107.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};